import { ca } from '@cian/analytics';

export function trackErrorClick() {
  return ca('event', {
    action: 'bti_click',
    category: 'card',
    label: 'error',
    name: 'oldevent',
    page: {
      pageType: 'Card',
    },
  });
}

export type TLabel = 'price' | 'estimate_button' | 'more';

export function trackEstimateClick(label: TLabel) {
  ca('event', {
    action: 'bti_click',
    category: 'card',
    label,
    name: 'oldevent',
    page: {
      pageType: 'Card',
    },
  });
}
